export default __webpack_public_path__ + "locales/pt-BR/translation.json";